import { Inject } from '@angular/core';
import { Component } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialogRef } from '@angular/material/dialog';
import { DialogContent } from 'app/modules/main/models/dialog-content';

@Component({
  selector: 'app-generic-error-popup',
  templateUrl: './error-popup.component.html',
})
export class ErrorPopupComponent {

  private readonly _title: string;
  private readonly _message: string;
  private readonly _allowClose: boolean;

  get title(): string {
    return this._title;
  }

  get message(): string {
    return this._message;
  }

  get allowClose(): boolean {
    return this._allowClose;
  }

  constructor(
    readonly dialogRef: MatDialogRef<ErrorPopupComponent>,
    @Inject(MAT_DIALOG_DATA) readonly content: DialogContent,
  ) {

    this._allowClose = content.allowClose;

    this._title = content.title;
    this._message = content.message;
  }

  close() {
    this.dialogRef.close();
  }

}
